import React, { useState } from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import CreateIcon from "@mui/icons-material/Create";
import { blue } from '@mui/material/colors';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import Modal from '@mui/material/Modal';
// import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MobileInvoice() {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
  setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <div className='MainView'>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Apartment")}
        />
        <h1>Invoice</h1>
      </div>
      <div className='topSpace'></div>
      <div className='tabView'>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Unpaid Invoice" {...a11yProps(0)} style={{width:'50%'}}/>
          <Tab label="Paid Invoice" {...a11yProps(1)} style={{width:'50%'}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileUnpaidInvoiceDetails')}>
        <div>
          <p className='invoiceNo'>Invoice no: 101</p>
        </div>
        <div className="famDetailsListTo">
          <p className='monthlyTxt'>Monthly Maintenance</p>
          <div className='tagInvoiceView'>
            <p className='tagInvoiceTxt'>Not Paid</p>
          </div>
        </div>
        <div className="famDetailsListTo">
          <p className='maintainTxt'>June</p>
          <p className='maintainTxt'><CurrencyRupeeIcon sx={{fontSize:14}} /> 1000</p>
        </div>
        <div className='dividerCommon' />
        <p className='periodTxt'>Period</p>
        <p className='dateInvcTxt'>22/06/2024 to 30/07/2024</p>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div>
          <p className='invoiceNo'>Invoice no: 101</p>
        </div>
        <div className="famDetailsListTo">
          <p className='monthlyTxt paidColor'>Monthly Maintenance</p>
          <div className='tagInvoiceView paidTagView'>
            <p className='tagInvoiceTxt paidColor'>Paid</p>
          </div>
        </div>
        <div className="famDetailsListTo">
          <p className='maintainTxt'>June</p>
          <p className='maintainTxt'><CurrencyRupeeIcon sx={{fontSize:14}} /> 1000</p>
        </div>
        <div className='dividerCommon' />
        <p className='periodTxt'>Period</p>
        <p className='dateInvcTxt'>22/06/2024 to 30/07/2024</p>
        </div>
      </CustomTabPanel>
      </Box>
    </div>
    </div>
  )
}

export default MobileInvoice